import axios from 'axios'
import { apiBaseUrl } from '@/variables/localVariables'

export class APIService {
  getFlight (daymonth, reference) {
    const url = `${apiBaseUrl}/flights/${daymonth}/${reference}`
    return axios.get(url)
  }
  saveLeg (reference, leg) {
    const url = `${apiBaseUrl}/flights/${reference}/legs/${leg.id}`
    return axios.put(url, leg)
  }
}
